// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.auth-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  padding: 2rem;
  animation: fadeInOverlay 0.3s ease-out forwards;
}

@keyframes fadeInOverlay {
  from {
    background-color: rgba(0, 0, 0, 0);
  }
  to {
    background-color: rgba(0, 0, 0, 0.5);
  }
}

.auth-modal {
  background: white;
  border-radius: 1rem;
  padding: 2.5rem;
  max-width: 400px;
  width: 100%;
  position: relative;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
  transform: scale(0.9) translateY(-20px);
  opacity: 0;
  animation: fadeInModal 0.3s ease-out 0.1s forwards;
}

@keyframes fadeInModal {
  from {
    transform: scale(0.9) translateY(-20px);
    opacity: 0;
  }
  to {
    transform: scale(1) translateY(0);
    opacity: 1;
  }
}

.auth-modal-close {
  position: absolute;
  top: 1rem;
  right: 1rem;
  background: none;
  border: none;
  font-size: 2rem;
  cursor: pointer;
  color: #64748b;
  width: 2.5rem;
  height: 2.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 0.5rem;
  transition: all 0.3s ease;
}

.auth-modal-close:hover {
  background-color: #f1f5f9;
  color: #0f172a;
}

.auth-modal h2 {
  margin: 0 0 1.5rem 0;
  color: #0f172a;
  font-size: 1.75rem;
  font-weight: 700;
}

.auth-error {
  background-color: #fee;
  color: #c33;
  padding: 0.75rem;
  border-radius: 0.5rem;
  margin-bottom: 1rem;
  font-size: 0.9rem;
  border: 1px solid #fcc;
  word-wrap: break-word;
  word-break: break-word;
  line-height: 1.5;
  max-height: 200px;
  overflow-y: auto;
}

.auth-form-group {
  margin-bottom: 1.5rem;
}

.auth-form-group label {
  display: block;
  margin-bottom: 0.5rem;
  font-weight: 500;
  color: #0f172a;
  font-size: 0.9rem;
}

.auth-form-group input {
  width: 100%;
  padding: 0.75rem;
  border: 2px solid #e2e8f0;
  border-radius: 0.5rem;
  font-size: 1rem;
  box-sizing: border-box;
  transition: border-color 0.3s ease;
}

.auth-form-group input:focus {
  outline: none;
  border-color: #28a745;
  box-shadow: 0 0 0 3px rgba(40, 167, 69, 0.1);
}

.auth-submit-btn {
  width: 100%;
  padding: 0.75rem;
  background-color: #28a745;
  color: white;
  border: none;
  border-radius: 0.5rem;
  font-weight: 600;
  cursor: pointer;
  margin-bottom: 1rem;
  font-size: 1rem;
  transition: background-color 0.3s ease;
}

.auth-submit-btn:hover:not(:disabled) {
  background-color: #218838;
}

.auth-submit-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.auth-divider {
  text-align: center;
  margin: 1.5rem 0;
  position: relative;
}

.auth-divider span {
  background: white;
  padding: 0 1rem;
  color: #64748b;
  position: relative;
  z-index: 1;
  font-size: 0.9rem;
}

.auth-divider::before {
  content: '';
  position: absolute;
  top: 50%;
  left: 0;
  right: 0;
  height: 1px;
  background: #e2e8f0;
}

.auth-google-btn {
  width: 100%;
  padding: 0.75rem;
  background: white;
  border: 2px solid #e2e8f0;
  border-radius: 0.5rem;
  font-weight: 600;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.75rem;
  font-size: 1rem;
  transition: all 0.3s ease;
}

.google-icon {
  flex-shrink: 0;
}

.auth-google-btn:hover:not(:disabled) {
  background-color: #f8f9fa;
  border-color: #cbd5e1;
}

.auth-google-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.auth-switch {
  text-align: center;
  margin-top: 1.5rem;
  color: #64748b;
  font-size: 0.9rem;
}

.auth-switch button {
  background: none;
  border: none;
  color: #28a745;
  font-weight: 600;
  cursor: pointer;
  text-decoration: underline;
  padding: 0;
  margin-left: 0.25rem;
}

.auth-switch button:hover {
  color: #218838;
}

.user-email {
  margin-right: 1rem;
  color: #64748b;
  font-size: 0.9rem;
}

.auth-message-banner {
  background-color: #d1ecf1;
  border: 1px solid #bee5eb;
  border-radius: 5px;
  padding: 12px;
  margin-bottom: 20px;
  text-align: center;
  animation: slideDown 0.3s ease-out;
}

.auth-message-banner strong {
  color: #0c5460;
  font-size: 1.1rem;
}

@keyframes slideDown {
  from {
    transform: translateY(-10px);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
}

/* Responsive Design */
@media (max-width: 480px) {
  .auth-modal-overlay {
    padding: 1rem;
  }

  .auth-modal {
    padding: 2rem 1.5rem;
  }

  .auth-modal h2 {
    font-size: 1.5rem;
  }
}

`, "",{"version":3,"sources":["webpack://./src/unAuth/components/AuthModal.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,kCAAkC;EAClC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,aAAa;EACb,+CAA+C;AACjD;;AAEA;EACE;IACE,kCAAkC;EACpC;EACA;IACE,oCAAoC;EACtC;AACF;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,kBAAkB;EAClB,0CAA0C;EAC1C,uCAAuC;EACvC,UAAU;EACV,kDAAkD;AACpD;;AAEA;EACE;IACE,uCAAuC;IACvC,UAAU;EACZ;EACA;IACE,iCAAiC;IACjC,UAAU;EACZ;AACF;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,cAAc;EACd,aAAa;EACb,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,WAAW;EACX,gBAAgB;EAChB,qBAAqB;EACrB,mBAAmB;EACnB,iBAAiB;EACjB,sBAAsB;EACtB,qBAAqB;EACrB,sBAAsB;EACtB,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,gBAAgB;EAChB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;EACrB,eAAe;EACf,sBAAsB;EACtB,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,4CAA4C;AAC9C;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,qBAAqB;EACrB,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,UAAU;EACV,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,OAAO;EACP,QAAQ;EACR,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;EACzB,qBAAqB;EACrB,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,0BAA0B;EAC1B,UAAU;EACV,oBAAoB;AACtB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE;IACE,4BAA4B;IAC5B,UAAU;EACZ;EACA;IACE,wBAAwB;IACxB,UAAU;EACZ;AACF;;AAEA,sBAAsB;AACtB;EACE;IACE,aAAa;EACf;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,iBAAiB;EACnB;AACF","sourcesContent":[".auth-modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: rgba(0, 0, 0, 0);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n  padding: 2rem;\n  animation: fadeInOverlay 0.3s ease-out forwards;\n}\n\n@keyframes fadeInOverlay {\n  from {\n    background-color: rgba(0, 0, 0, 0);\n  }\n  to {\n    background-color: rgba(0, 0, 0, 0.5);\n  }\n}\n\n.auth-modal {\n  background: white;\n  border-radius: 1rem;\n  padding: 2.5rem;\n  max-width: 400px;\n  width: 100%;\n  position: relative;\n  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);\n  transform: scale(0.9) translateY(-20px);\n  opacity: 0;\n  animation: fadeInModal 0.3s ease-out 0.1s forwards;\n}\n\n@keyframes fadeInModal {\n  from {\n    transform: scale(0.9) translateY(-20px);\n    opacity: 0;\n  }\n  to {\n    transform: scale(1) translateY(0);\n    opacity: 1;\n  }\n}\n\n.auth-modal-close {\n  position: absolute;\n  top: 1rem;\n  right: 1rem;\n  background: none;\n  border: none;\n  font-size: 2rem;\n  cursor: pointer;\n  color: #64748b;\n  width: 2.5rem;\n  height: 2.5rem;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 0.5rem;\n  transition: all 0.3s ease;\n}\n\n.auth-modal-close:hover {\n  background-color: #f1f5f9;\n  color: #0f172a;\n}\n\n.auth-modal h2 {\n  margin: 0 0 1.5rem 0;\n  color: #0f172a;\n  font-size: 1.75rem;\n  font-weight: 700;\n}\n\n.auth-error {\n  background-color: #fee;\n  color: #c33;\n  padding: 0.75rem;\n  border-radius: 0.5rem;\n  margin-bottom: 1rem;\n  font-size: 0.9rem;\n  border: 1px solid #fcc;\n  word-wrap: break-word;\n  word-break: break-word;\n  line-height: 1.5;\n  max-height: 200px;\n  overflow-y: auto;\n}\n\n.auth-form-group {\n  margin-bottom: 1.5rem;\n}\n\n.auth-form-group label {\n  display: block;\n  margin-bottom: 0.5rem;\n  font-weight: 500;\n  color: #0f172a;\n  font-size: 0.9rem;\n}\n\n.auth-form-group input {\n  width: 100%;\n  padding: 0.75rem;\n  border: 2px solid #e2e8f0;\n  border-radius: 0.5rem;\n  font-size: 1rem;\n  box-sizing: border-box;\n  transition: border-color 0.3s ease;\n}\n\n.auth-form-group input:focus {\n  outline: none;\n  border-color: #28a745;\n  box-shadow: 0 0 0 3px rgba(40, 167, 69, 0.1);\n}\n\n.auth-submit-btn {\n  width: 100%;\n  padding: 0.75rem;\n  background-color: #28a745;\n  color: white;\n  border: none;\n  border-radius: 0.5rem;\n  font-weight: 600;\n  cursor: pointer;\n  margin-bottom: 1rem;\n  font-size: 1rem;\n  transition: background-color 0.3s ease;\n}\n\n.auth-submit-btn:hover:not(:disabled) {\n  background-color: #218838;\n}\n\n.auth-submit-btn:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n.auth-divider {\n  text-align: center;\n  margin: 1.5rem 0;\n  position: relative;\n}\n\n.auth-divider span {\n  background: white;\n  padding: 0 1rem;\n  color: #64748b;\n  position: relative;\n  z-index: 1;\n  font-size: 0.9rem;\n}\n\n.auth-divider::before {\n  content: '';\n  position: absolute;\n  top: 50%;\n  left: 0;\n  right: 0;\n  height: 1px;\n  background: #e2e8f0;\n}\n\n.auth-google-btn {\n  width: 100%;\n  padding: 0.75rem;\n  background: white;\n  border: 2px solid #e2e8f0;\n  border-radius: 0.5rem;\n  font-weight: 600;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.75rem;\n  font-size: 1rem;\n  transition: all 0.3s ease;\n}\n\n.google-icon {\n  flex-shrink: 0;\n}\n\n.auth-google-btn:hover:not(:disabled) {\n  background-color: #f8f9fa;\n  border-color: #cbd5e1;\n}\n\n.auth-google-btn:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n.auth-switch {\n  text-align: center;\n  margin-top: 1.5rem;\n  color: #64748b;\n  font-size: 0.9rem;\n}\n\n.auth-switch button {\n  background: none;\n  border: none;\n  color: #28a745;\n  font-weight: 600;\n  cursor: pointer;\n  text-decoration: underline;\n  padding: 0;\n  margin-left: 0.25rem;\n}\n\n.auth-switch button:hover {\n  color: #218838;\n}\n\n.user-email {\n  margin-right: 1rem;\n  color: #64748b;\n  font-size: 0.9rem;\n}\n\n.auth-message-banner {\n  background-color: #d1ecf1;\n  border: 1px solid #bee5eb;\n  border-radius: 5px;\n  padding: 12px;\n  margin-bottom: 20px;\n  text-align: center;\n  animation: slideDown 0.3s ease-out;\n}\n\n.auth-message-banner strong {\n  color: #0c5460;\n  font-size: 1.1rem;\n}\n\n@keyframes slideDown {\n  from {\n    transform: translateY(-10px);\n    opacity: 0;\n  }\n  to {\n    transform: translateY(0);\n    opacity: 1;\n  }\n}\n\n/* Responsive Design */\n@media (max-width: 480px) {\n  .auth-modal-overlay {\n    padding: 1rem;\n  }\n\n  .auth-modal {\n    padding: 2rem 1.5rem;\n  }\n\n  .auth-modal h2 {\n    font-size: 1.5rem;\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
